//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useState, useEffect, useCallback, useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

// custom pages
import "assets/css/custom.css";
import useForm from "helpers/useForm";
import { otpValidate } from "helpers/validateRules/auth";
import auth from "apis/auth/auth";
import VerifyOTPParent from "components/AuthPages/VeriftOtpParent";
import { verifyOTPStyles } from "./styles";
import Loader from "components/Loader/Loader";
import Context from "context/context";

// material-ui
import {
  ThemeProvider,
  withStyles,
  createMuiTheme,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import Tooltip from "@material-ui/core/Tooltip";
// material-ui icons
import ArrowBackOutlinedIcon from "@material-ui/icons/ArrowBackOutlined";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "#D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#fff",
    },
    "& .MuiInputBase-input": {
      color: "#fff",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#fff!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#fff!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#fff",
      },
      "&:hover fieldset": {
        borderColor: "#fff",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#fff",
      },
    },
  },
})(TextField);

const formLabelsTheme = createMuiTheme({
  overrides: {
    MuiFormLabel: {
      asterisk: {
        color: "#db3131",
        "&$error": {
          color: "#db3131",
        },
      },
    },
  },
  palette: {
    primary: {
      main: "#000000",
    },
  },
});

const toastCss = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: false,
  draggable: true,
  progress: undefined,
};

const initialValues = {
  otp: "",
};

export default function VerifyOTP() {
  const history = useHistory();
  const { state, dispatch } = useContext(Context);
  const location = useLocation();
  const { verifyEmail, verifyOTP, forgotPassword } = auth();

  const classes = verifyOTPStyles();
  const [minute, setMinute] = useState(4);
  const [second, setSecond] = useState(59);
  const [isExpire, setIsExpire] = useState(false);
  const [isResend, setIsResend] = useState(false);
  const [resendEmailResponse, setResendEmailResponse] = useState({});
  const [states, setstates] = useState({
    disableButton: false,
    tooltipName: "",
    tooltipCondition: false,
  });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  useEffect(() => {
    if (location.state && location.state.emailResponse) {
      return;
    }
    history.goBack();
  }, []);

  // useEffect(() => {
  //   setInterval(function () {
  //     var d = new Date();
  //     var seconds = d.getMinutes() * 60 + d.getSeconds(); //convet 00:00 to seconds for easier caculation
  //     var fiveMin = 60 * 5; //five minutes is 300 seconds!
  //     var timeleft = fiveMin - (seconds % fiveMin); // let's say 01:30, then current seconds is 90, 90%300 = 90, then 300-90 = 210. That's the time left!
  //     var result = parseInt(timeleft / 60) + ":" + (timeleft % 60); //formart seconds into 00:00
  //     console.log({ result });
  //   }, 500);
  // }, []);

  // handling inputs
  const { values, errors, handleSubmit, handleChange, setUpdateValue } =
    useForm(initialValues, handleVerifyOTP, otpValidate);

  // verify otp func
  async function handleVerifyOTP() {
    let emailResponse = location.state.emailResponse;
    let obj = { ...emailResponse, ...values };
    dispatch({ type: "SET_LOADING", payload: true });
    let res = await verifyOTP(obj);
    dispatch({ type: "SET_LOADING", payload: false });
    if (res && res.type == "success") {
      return history.push("/resetpassword", {
        emailResponse: emailResponse,
      });
    }
    toast.error(res && res.message ? res.message : "something went wrong");
    setStates({ disableButton: false });
  }

  // resend otp func
  // async function handleResendOTP() {
  //   let values = {
  //     email:
  //       location.state &&
  //       location.state.emailResponse &&
  //       location.state.emailResponse.email,
  //     type: "ResendOTP",
  //   };
  //   if (location.state.emailResponse.page === "signup") {
  //     dispatch({ type: "SET_LOADING", payload: true });
  //     let res = await verifyEmail(values);
  //     if (res && res.type == "success") {
  //       dispatch({ type: "SET_LOADING", payload: false });
  //       toast.success(res && res.message, toastCss);
  //       history.replace("/verify-signupotp", {
  //         emailResponse: { page: "signup", ...res },
  //       });
  //       return toast.success(res.status, toastCss);
  //     }
  //     toast.error(res && res.status, toastCss);
  //   }
  //   if (location.state.emailResponse.page === "forgotPassword") {
  //     dispatch({ type: "SET_LOADING", payload: true });
  //     let res = await forgotPassword(values);
  //     dispatch({ type: "SET_LOADING", payload: false });
  //     if (res && res.type === "success") {
  //       setIsResend(true);
  //       setResendEmailResponse(res);
  //       if (isExpire) {
  //         setIsExpire(false);
  //         setMinute(4);
  //         setSecond(59);
  //       }
  //     }
  //     dispatch({ type: "SET_LOADING", payload: false });
  //   }
  // }

  return (
    <VerifyOTPParent>
      <div className={classes.verifyOTPText}>
        <ArrowBackOutlinedIcon
          className={classes.verifyOTPIcon}
          onClick={() => {
            history.goBack();
          }}
        />
        <br />
        Verify OTP
      </div>
      <Loader Loading={state.loading}>
        <div className={classes.inputMainDiv}>
          <ThemeProvider theme={formLabelsTheme}>
            <CssTextField
              id="emailId"
              label="Enter OTP"
              type={"number"}
                onWheel={(e) => e.target.blur()}
              autoComplete="off"
              required
              fullWidth={true}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Tooltip
                      arrow
                      placement="top-start"
                      disableFocusListener
                      disableHoverListener
                      disableTouchListener
                      title=""
                      open={
                        states.tooltipName === "otp" && states.tooltipCondition
                          ? true
                          : false
                      }
                    >
                      <IconButton
                        onClick={() =>
                          setStates({
                            tooltipName: "otp",
                            tooltipCondition: !states.tooltipCondition,
                          })
                        }
                        className={classes.otpInputIconBtn}
                      >
                        <InfoOutlinedIcon className={classes.otpInputIcon} />
                      </IconButton>
                    </Tooltip>
                  </InputAdornment>
                ),
              }}
              value={values.otp}
              onChange={(e) => {
                handleChange({ name: "otp", value: e.target.value });
              }}
            />
          </ThemeProvider>
          {errors.otp && <span className="error">{errors.otp}</span>}
        </div>
      </Loader>
      <div className={classes.btnDiv}>
        <Button
          variant="contained"
          className={classes.btn}
          disabled={isExpire}
          onClick={() => {
            handleSubmit();
            setStates({ disableButton: true });
          }}
        >
          Verify
        </Button>
      </div>
    </VerifyOTPParent>
  );
}
